<template>
  <div class="file">
    <v-btn
      ref="fileOpenButton"
      class="file_button"
      :aria-label="$t('Загрузить документ')"
      @click="changeModal"
    >
        Загрузить документ
    </v-btn>


    <div
      class="file_modal"
      v-if="showModal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="file-modal-title"
      @keydown.esc="changeModal"
    >

      <div class="file_block" tabindex="-1">
        <span
          ref="fileModalClose"
          class="pro-icon-close1 file_modal-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Закрыть')"
          @click="changeModal"
          @keyup.enter="changeModal"
          @keyup.space="changeModal"
        />
        <span id="file-modal-title" class="sr-only">{{ $t('Загрузить документ') }}</span>
        <div class="file_input save-document">
          <v-file-input
            label="Загрузить документ"
            v-model="form.file"
            :accept="formats"
          >
          </v-file-input>
        </div>

        <v-textarea
          v-model="form.description"
          class="file_description"
          label="Название документа"
          outlined
          rounded
        />

        <v-btn
          class="file_button"
          @click="saveDocument"
        >
          Сохранить
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FileInput",
  props: {
    formats: {
      type: Array,
      default: () => {
        return ['.jpeg','.jpg', '.png', '.pdf']
      }
    }
  },

  data () {
    return {
      form: {
        file: null,
        description: ''
      },
      isSelecting: false,
      showModal: false,
    }
  },

  watch: {
    showModal (value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.fileModalClose && this.$refs.fileModalClose.focus()
        })
      } else {
        this.$refs.fileOpenButton && this.$refs.fileOpenButton.$el && this.$refs.fileOpenButton.$el.focus()
      }
    }
  },

  methods: {
    changeModal () {
      this.showModal = !this.showModal
    },

    handleFileImport() {
        this.isSelecting = true;

        window.addEventListener('focus', () => {
            this.isSelecting = false
        }, { once: true });

        this.$refs.uploader.click();
    },

    saveDocument() {
      this.changeModal()
      this.$emit('save', this.form)
    },
  }
}
</script>
<style lang="scss" scoped>

  .file {
    padding: 20px 0;

    &_block {
      width: 500px;
      background-color: #fff;
      padding: 30px;
      position: relative;
    }

    &_modal {
      position: fixed;
      width: 100%;
      background: rgb(62,65,70, 0.6);
      height: 100vh;
      top: 0;
      left: 0;
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;

      &-close {
        right: 10px;
        top: 10px;
        position: absolute;
        cursor: pointer;
      }
    }

    &_button {
      background: #2096f3 !important;
      color: #fff;
      cursor: pointer;
      margin-top: 20px;
      border-radius: 10px;
    }

    &_item {
      padding: 15px 0;
    }

    &_description {
      margin-top: 40px;
    }
  }
</style>
